import { Para, Stack } from '@drycut/ui-components';

type Props = {
  couponCode: string;
};

export default function InvitationSteps({ couponCode }: Props): React.ReactElement {
  return (
    <Stack gap={4} className="text-left text-pretty my-3">
      <Para className="text-center lg:text-start font-aribaubold">So einfach geht's:</Para>

      <Stack as="ol" gap={4} className="list-inside list-decimal">
        <Para as="li">
          Den Link unten oder den Gutscheincode{' '}
          <strong className="font-aribaubold">{couponCode}</strong> an Freunde und Bekannte
          weiterleiten
        </Para>

        <Para as="li">
          Sie bekommen damit ihren ersten DRYCUT für CHF 29 statt 42 (nur gültig für Neukunden)
        </Para>

        <Para as="li">
          Für jeden geworbenen Neukunden schicken wir Dir einen Gutschein für CHF 13 per SMS
        </Para>
      </Stack>
    </Stack>
  );
}
